import { CircularProgress } from "@material-ui/core";
import MaterialTable from "material-table";
import React, { useEffect, useState } from "react";
import { FaArrowLeft } from "react-icons/fa";
import { Link } from "react-router-dom";
import ErrorMessage from "../../Common/ErrorMessage";
import userService from "../../services/user.service";
import StorageApprovalPopup from "./StorageApprovalPopup";
import SuperAdminDashboard from "./superAdminDashboard";

const StorageRequest = () => {
  const [hoursRequestData, setHoursRequestData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getHoursRequestData();
  }, []);

  const getHoursRequestData = () => {
    setLoading(true);
    userService.getAddHoursRequest().then((res) => {
      const data = res.data.data.schoolAdminSportDetailsResponses;
      setHoursRequestData(data);
      setLoading(false);
    });
  };

  const columns = [
    {
      title: "id",
      field: "id",
      hidden: true,
    },
    {
      title: "School Name",
      field: "schoolName",
      render: (row) => (
        <div className="table-clmn  ">
          <span className=""> {row.schoolName.slice(0, 14)}... </span>
        </div>
      ),
    },
    {
      title: "Total Storage",
      field: " totalStorage",
      render: (row) => (
        <div className="table-clmn  text-center">
          <span className=""> {row.totalStorage}</span>
        </div>
      ),
    },
    {
      title: "Used Storage",
      field: "usedStorage",
      render: (row) => (
        <div className="table-clmn  text-center">
          <span className=""> {row.usedStorage.toFixed(3)}</span>
        </div>
      ),
    },
    {
      title: "Available Storage",
      field: "availableHours",
      render: (row) => (
        <div className="table-clmn  text-center">
          <span className=""> {row.availableHours.toFixed(3)}</span>
        </div>
      ),
    },
    {
      title: "REQUEST HOURS  ",
      field: "hoursPurchasedPending",
      render: (row) => (
        <div className="table-clmn  text-center">
          <span className=""> {row.hoursPurchasedPending}</span>
        </div>
      ),
    },

    {
      title: "",
      render: (row) => (
        <div className="table-clmn cursor-pointer text-center">
          <StorageApprovalPopup
            rowData={row}
            getHoursRequestData={getHoursRequestData}
          />
        </div>
      ),
    },
  ];
  return (
    <div>
      <div className="content">
        <SuperAdminDashboard />
        <div className="content-layout p-0">
          <div className="mng-header row ">
            <div className="fs-20 black bold ml-14">
              <Link to="/storage" className="">
                <span className=" backbt-width">
                  <FaArrowLeft className=" text-dark "></FaArrowLeft>
                </span>
              </Link>
              Hours Purchase Request {""}(
              {hoursRequestData.length ? hoursRequestData.length : 0})
            </div>
          </div>
          <div className="clear10"></div>
          {loading === true && (
            <CircularProgress
              style={{
                width: "45px",
                height: "44px",
                position: "absolute",
                left: "57%",
                top: "47%",
                zIndex: "99",
              }}
              color="secondary"
            />
          )}
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 plr pt-1">
            {hoursRequestData.length > 0 && (
              <MaterialTable
                id="storageTbl"
                style={{ marginBottom: "20px" }}
                title=""
                data={hoursRequestData}
                columns={columns}
                options={{
                  filtering: false,
                  headerStyle: {
                    fontFamily: "Rajdhani-Bold",
                    fontSize: 14,
                    backgroundColor: "#F0F8FF",
                  },
                  rowStyle: { fontSize: 17, fontFamily: "Rajdhani-SemiBold" },
                  pageSize: 10,
                }}
              ></MaterialTable>
            )}

            {hoursRequestData.length === 0 && !loading && <ErrorMessage />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default StorageRequest;
